import { IDiseaseCardInfo } from '@pharmsnap/shared/src/types'
import { defineComponent, PropType } from '@vue/composition-api'
import '../../../../assets/icon-svg/disease.svg'
import { CTRL_C_INFO } from '../../../../utils'
import { BMicroEntityCard } from '../BMicroEntityCard/BMicroEntityCard'
import $classes from '../EntityCard.module.scss'
import cmpCn from '../locales/cn.json'
import cmpEn from '../locales/en.json'
import cn from './locales/cn.json'
import en from './locales/en.json'

export const BDiseaseCard = defineComponent({
  name: 'BDiseaseCard',
  i18n: {
    messages: {
      cn: { ...cn, ...cmpCn },
      en: { ...en, ...cmpEn },
    },
  },
  props: {
    data: {
      type: Object as PropType<IDiseaseCardInfo>,
    },
    id: {
      type: String,
      required: true,
    },
    drug_id: {
      type: String,
    },
    direction: {
      type: String as PropType<'vertical' | 'horizontal'>,
      default: 'horizontal',
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    return {}
  },
  methods: {
    renderContent() {
      return (
        <BMicroEntityCard
          id={this.id}
          drug_id={this.drug_id}
          type="disease"
          direction={this.direction}
          data={this.data}
          onLoaded={() => this.$emit('loaded')}
        />
      )
    },
  },
  render() {
    return (
      <div class={[$classes.card, CTRL_C_INFO, !this.border && $classes.cardNoBorder]}>
        <div class={$classes.body}>{this.renderContent()}</div>
      </div>
    )
  },
})
